import firebase from '../../firebase'
const db = firebase.firestore()
import { FS_COLLECTIONS } from '@/firebase'
var cargadorCorporativo = null

const store = {
  state: {
    corporativo: {},
    corporativoinfo: {}
  },
  getters: {
    corporativo(state) {
      return state.corporativo
    },
    corporativoinfo(state) {
      return state.corporativoinfo
    }
    /* sucursalPorID(state) {
      return id => state.sucursales.find(sucursal => sucursal.id === id)
    } */
  },
  mutations: {
    ASIGNA_CORPORATIVO(state, corporativo) {
      state.corporativo = corporativo
    },
    ASIGNA_CORPORATIVOINFO(state, corporativoinfo) {
      state.corporativoinfo = corporativoinfo
    },
    /* agregarSucursal(state, sucursal) {
      state.sucursales.push(sucursal)
    },
    actualizarSucursal(state, sucursalActualizar) {
      var indice = state.sucursales.findIndex(
        sucursal => sucursal.id == sucursalActualizar.id
      )
      state.sucursales.splice(indice, 1, sucursalActualizar)
    },
    cargarSucursales(state, sucursales) {
      state.sucursales = sucursales
    },
    actualizaCorporativo(state, corporativo) {
      state.corporativo = corporativo
      //console.log('state corp: ' + state.corporativo)
    },
    cargarSucursales(state, sucursales) {
      state.sucursales = sucursales
    } */
  },
  actions: {
    cargaCorporativo({ dispatch, getters, commit }) {
      return new Promise((resolve, reject) => {
        console.log("Corporativo carga ", getters.corporativo)
        if (Object.keys(getters.corporativo).length<=1) {

          if(getters.corporativo.id===undefined)
            return ;

          let docRef = db
            .collection(FS_COLLECTIONS.CORPORATIVOS)
            .doc(getters.corporativo.id)

          cargadorCorporativo = docRef.onSnapshot(doc => {
            console.log("ASIGNA CORPORATIVO")
            console.log(doc.data())
            var corp = doc.data()
            corp.id = getters.corporativo.id
            dispatch('cargaFranquiciasCorporativo', corp.franquicias)
            commit('ASIGNA_CORPORATIVO', corp)
            resolve(corp)
          })
        } else {
          resolve(getters.corporativo)
        }
      })
    },
    cargaInfoCorporativo({ dispatch, getters, commit }) {
      return new Promise((resolve, reject) => {
          let docRef = db
            .collection(FS_COLLECTIONS.CORPORATIVOS)
            .doc(getters.corporativo.id)

          cargadorCorporativo = docRef.onSnapshot(doc => {
            console.log("ASIGNA INFO CORPORATIVO")
            console.log(doc.data())
            var corp = doc.data()
            corp.id = getters.corporativo.id
            resolve(corp)
          })
        
      })
    },
    cargaInfoCorporativoGet({ dispatch, getters, commit }, idCorporativo) {
      return new Promise((resolve, reject) => {
          let docRef = db
            .collection(FS_COLLECTIONS.CORPORATIVOS)
            .doc(idCorporativo)

          cargadorCorporativo = docRef.onSnapshot(doc => {
            console.log("ASIGNA INFO CORPORATIVO")
            console.log(doc.data())
            var corp = doc.data()
            corp.id = idCorporativo
            commit('ASIGNA_CORPORATIVOINFO', corp)
            resolve(corp)
          })
        
      })
    },
    actualizaCorporativo({}, corporativoInfo) {
      return db
        .collection(FS_COLLECTIONS.CORPORATIVOS)
        .doc(corporativoInfo.id)
        .update(corporativoInfo)
    },
    estatusSucursal({ dispatch, getters }, params) {
      return new Promise((resolve, reject) => {
        let idSucursal = params.id_sucursal;
        let docRef = db
            .collection("Sucursales")
            .doc(idSucursal);

        docRef.get().then(function(sucursalObtenida) {

          if (sucursalObtenida.exists) {
              //console.log("Document data:", sucursalObtenida.data());
              let actualiza = sucursalObtenida.data();
              
              actualiza.info.estatus = 'baja';
              actualiza.estatus.estatus = 'baja';
              if(params.accion == 'activar'){
                actualiza.info.estatus = 'activo';
                actualiza.estatus.estatus = 'activo';
              }
              //console.log("TCL: eliminarSucursal -> actualiza.info.estatus", actualiza)

              db.collection("Sucursales").doc(idSucursal)
                .update(actualiza)

          } else {
              // sucursalObtenida.data() will be undefined in this case
              console.log("No such document!");
          }
        }).catch(function(error) {
            console.log("Error getting document:", error);
        });

        

          resolve()
      })
    },
  }
}

export default store



// WEBPACK FOOTER //
// ./src/store/corporativo/corporativo.js